import { Button, Stack, Text } from '@chakra-ui/react'
import { faVideo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

import { getSessionJoinRedirectUrl } from '@/client/services/url'

import type { PostDetails } from '@/components/Community/Post/types'
import ShwLink from '@/components/ShwLink'
import Avatar from '@/components/Worlds/UI/Avatar/Avatar'

import CancelLiveHelpRequestModal from './CancelLiveHelpRequestModal'
import { LIVE_HELP_LEARNER_TIMEOUT_MINUTES } from './constants'
import type { LiveHelpRequestWithSessionDetails } from './types'

export default function AuthorJoinLiveHelpBanner({
  post,
  liveHelpRequest,
}: {
  post: PostDetails
  liveHelpRequest: LiveHelpRequestWithSessionDetails
}): JSX.Element {
  const [showCancelRequestModal, setShowCancelRequestModal] = useState(false)

  const { session } = liveHelpRequest

  return (
    <>
      <CancelLiveHelpRequestModal
        postId={post.id}
        open={showCancelRequestModal}
        onClose={() => setShowCancelRequestModal(false)}
      />
      <Stack
        direction="column"
        width="100%"
        p="16px"
        bgColor="bg.info"
        borderRadius="8px"
        spacing="16px"
      >
        <Stack
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'left', md: 'center' }}
        >
          <Stack direction="row" alignItems="center" spacing="16px">
            <Avatar user={session.host.user} size="md" />
            <Stack spacing={0}>
              <Text fontWeight="bold">{session.host.user.displayName} is ready to help you!</Text>
              <Text>
                Please join your tutor&apos;s room within {LIVE_HELP_LEARNER_TIMEOUT_MINUTES}{' '}
                minutes or they may help someone else.
              </Text>
            </Stack>
          </Stack>
          <Stack direction="column" spacing="16px">
            <ShwLink href={getSessionJoinRedirectUrl(session.id, false)} isExternal>
              <Button leftIcon={<FontAwesomeIcon icon={faVideo} />}>Join Zoom Room</Button>
            </ShwLink>
            <Button
              variant="danger-outline"
              flexShrink={0}
              onClick={() => setShowCancelRequestModal(true)}
              height="auto"
            >
              I don&apos;t need help anymore
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </>
  )
}
